import { inject } from 'aurelia';
import { I18N } from '@aurelia/i18n';
import { ApiResponse } from '../../apis/api-base';
import { HttpError } from './http-error';

@inject(I18N)
export class HttpErrorHelper {
    private _i18n: I18N;
    constructor(i18n: I18N) {
        this._i18n = i18n;
    }

    public getTranslatedHttpErrors(errorResponse: ApiResponse): HttpError[] {
        const errors = new Array<HttpError>();
        if (errorResponse?.statusCode === 429) {
            const rateLimited = new HttpError();
            rateLimited.message = this._i18n.tr('ui:too_many_requests');
            rateLimited.code = 429;
            rateLimited.scope = 'rate-limit';
            rateLimited.metadata = '';
            errors.push(rateLimited);
        } else if (!errorResponse || !Array.isArray(errorResponse.content)) {
            const errorContent = new HttpError();
            errorContent.message = 'An undefined error occurred';
            errorContent.code = 1000;
            errorContent.scope = '8174f49c-e3af-43de-bca0-ef6a440c923e';
            errorContent.metadata = '';
            errors.push(errorContent);
        } else {
            for (const content of errorResponse.content) {
                const errorContent = new HttpError();
                errorContent.code = content.code;
                errorContent.scope = content.scope;
                errorContent.message = this._translateErrorMessage(content);
                errorContent.metadata = content.metadata;
                errors.push(errorContent);
            }
        }
        return errors;
    }

    public containsError(err: any, scope: string, code: number): boolean {
        const errors = this.getTranslatedHttpErrors(err);
        return errors.any(e => e.code === code && e.scope.toLowerCase() === scope.toLowerCase());
    }

    private _translateErrorMessage(httpError: HttpError): string {
        let translated = this._i18n.tr('errors:' + httpError.scope + '.' + httpError.code);
        if (translated === httpError.scope + '.' + httpError.code) {
            translated = httpError.message + '. ErrorCode: ' + httpError.code + ', Scope: ' + httpError.scope + '.';
        } else {
            translated += '.';
        }
        return translated;
    }
}
